import NotFoundPage from "@/components/errors/404";

const Error = () => {
  return <NotFoundPage />;
};

export default Error;
